import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { AppService } from "../services/app.service";
import { FormControl } from "@angular/forms";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/throttleTime";
import "rxjs/add/observable/fromEvent";
import { Subscription } from "rxjs";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";

@Component({
  selector: "app-physician-information",
  templateUrl: "./physician-information.component.html",
})
export class PhysicianInformationComponent implements OnInit {
  modalRef: BsModalRef;
  rowsData = [
    {
      title: "First Name",
      sorting: true,
      name: "physicianFirstName",
      underline: true,
    },
    {
      title: "Last Name",
      sorting: true,
      name: "physicianLastName",
      underline: true,
    },
    { title: "Address", tooltip: true },
    { title: "Mobile Number" },
    { title: "Fax Number" },
    { title: "Physician Contact" },
    { title: "DPI", sorting: true, name: "" },
    { title: "Tax ID", sorting: true, name: "" },
    { title: "Patient Type" },
  ];

  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "physicianCreatedOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  maxSizeItemValue: any;
  routerName = "";

  constructor(
    private modalService: BsModalService,
    private appService: AppService,
    private supportService: SupportService,
    private location: Location
  ) {}

  ngOnInit() {
    // debounce keystroke events
    // this.formCtrlSub = this.firstNameControl.valueChanges
    //   .debounceTime(3000)
    //   .subscribe(newValue => {
    //     this.searchPatient = newValue;
    //     console.log("szc");
    //     this.getPatientList('');;
    //   });

    this.supportService.physicianpage.subscribe((res) => {
      this.getPhysicianList("");
    });

    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getPhysicianList(event);
      }
    });

    this.checkUrl();
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurMethod(val) {
    if (val) {
      this.maxSizeItem = val;
    } else {
      this.maxSizeItem = 10;
    }
    this.currentPage = 1;
    this.getPhysicianList("");
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.getPhysicianList("");
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getPhysicianList("");
  }

  getPhysicianList(event) {
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
      };
    }

    this.appService.getPhysicianListbytc(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.totalItems = res["count"];
              let address = "";
              if (obj.physicianAddressLine1) {
                address += obj.physicianAddressLine1 + ",";
              }
              if (obj.physicianAddressLine2) {
                address += obj.physicianAddressLine2 + ",";
              }

              if (obj.physicianCityName) {
                address += obj.physicianCityName + ",";
              }

              if (obj.physicianStateName) {
                address += obj.physicianStateName + ",";
              }

              if (obj.physicianCountryName) {
                address += obj.physicianCountryName;
              }
              this.columnsData = this.columnsData.concat({
                param1: obj.physicianFirstName,
                param2: obj.physicianLastName,
                param3: address ? address : "-",
                param4:
                  obj.physicianPhone && obj.physicianPhoneCode === "+91"
                    ? obj.physicianPhoneCode +
                      " " +
                      obj.physicianPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.physicianPhone && obj.physicianPhoneCode === "+1"
                    ? obj.physicianPhoneCode +
                      " " +
                      obj.physicianPhone.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param5:
                  obj.physicianFax && obj.physicianFaxCode === "+91"
                    ? obj.physicianFaxCode +
                      " " +
                      obj.physicianFax.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.physicianFax && obj.physicianFaxCode === "+1"
                    ? obj.physicianFaxCode +
                      " " +
                      obj.physicianFax.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param6:
                  obj.physicianContactFirstName && obj.physicianContactLastName
                    ? obj.physicianContactFirstName +
                      " " +
                      obj.physicianContactLastName
                    : obj.physicianContactFirstName &&
                      !obj.physicianContactLastName
                    ? obj.physicianContactFirstName
                    : !obj.physicianContactFirstName &&
                      obj.physicianContactLastName
                    ? obj.physicianContactLastName
                    : "-",
                param7: obj.physiciandpi ? obj.physiciandpi : "-",
                param8: obj.physiciantaxid ? obj.physiciantaxid : "-",
                param9: obj.patientType
                  ? obj.patientType === "IC"
                    ? "IC"
                    : "SchedMed"
                  : "-",
                param10: obj.physicianId ? obj.physicianId : "-",
                param13: "Double click for view",
              });
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({ class: "modal-xl" })
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getPhysicianList(event);
  }
}
